import { Quote } from "lucide-react";
import { Reveal, ChapterTag } from "@/components/Reveal";
import { useLang } from "@/i18n";

export default function Testimonials() {
  const { t } = useLang();
  return (
    <section id="testimonials" className="relative py-28 lg:py-40 border-t border-white/10" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <ChapterTag index="03" label={t.testimonials.tag} />
          <h2 className="font-display font-black tracking-tighter leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white mt-6 max-w-2xl" data-testid="testimonials-heading">
            {t.testimonials.heading}
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {t.testimonials.items.map((tst, i) => (
            <Reveal key={tst.name} delay={i * 0.1}>
              <figure
                className="h-full border border-white/10 rounded-xl bg-[#0A0A0F] p-8 flex flex-col justify-between transition-[border-color,transform] duration-500 hover:border-brand/60 hover:-translate-y-1"
                data-testid={`testimonial-card-${i}`}
              >
                <div>
                  <Quote size={22} className="text-brand-light" strokeWidth={1.5} />
                  <blockquote className="mt-6 text-neutral-300 leading-relaxed text-sm">"{tst.quote}"</blockquote>
                </div>
                <figcaption className="mt-8 pt-6 border-t border-white/10">
                  <p className="font-display font-bold text-white text-sm">{tst.name}</p>
                  <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500 mt-1.5">{tst.role}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
